import React from "react";
import styled from "react-emotion";
import html2canvas from "html2canvas";
import { Icon } from "antd";

const TextAd = ({ parentId, adSize, previewObject }) => {
  if (previewObject.headline === "") previewObject.headline = "Headline";
  if (previewObject.description === "")
    previewObject.description = "Description";
  if (previewObject.businessName === "")
    previewObject.businessName = "Business Name";

  const TextAd = styled("div")({
    width: adSize.width,
    height: adSize.height,
    button: {
      marginTop: "5px",
      width: "100px"
    }
  });

  const TextAdTitle = styled("div")({
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "12px"
  });

  const TextAdContainer = styled("div")({
    position: "relative",
    height: "100%",
    border: "1px solid #eee",
    wordBreak: "break-word"
  });

  const TextAdContainerImage = styled("div")({
    height: "75%",
    textAlign: "left",
    paddingLeft: "20px",
    h1: {
      padding: "15px 2px",
      margin: "auto",
      fontWeight: "700",
      wordBreak: "break-word"
    },
    p: {}
  });

  const Footer = styled("div")({
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "20%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "baseline",
    background: "#eee"
  });

  const download = elementId => {
    const parentElement = document.getElementById(parentId);
    html2canvas(parentElement.querySelector(`#${elementId}`), {
      useCORS: true,
      profile: true,
      allowTaint: true, //you can add this property
      scale: 1
      // dpi: 300
    }).then(canvas => {
      var a = document.createElement("a");
      a.href = canvas
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      a.download = "banner.jpg";
      a.click();
    });
  };

  const { width, height } = adSize;
  return (
    <TextAd>
      <TextAdTitle>
        Example of your text ad at {width}x{height}
        <Icon
          type="download"
          onClick={() =>
            download("text-ad-container", "", "", {
              width: "100%",
              height: "initial"
            })
          }
          title="Download"
          style={{ fontSize: "18px", marginLeft: "10px" }}
        />
      </TextAdTitle>
      <TextAdContainer id="text-ad-container">
        <TextAdContainerImage>
          <h1>{previewObject.headline}</h1>
          <p>{previewObject.businessName}</p>
          <p>{previewObject.description}</p>
        </TextAdContainerImage>
        <Footer>
          <button
            type="primary"
            shape="round"
            className="text-ad-footer-button"
            style={{ width: "150px", cursor: "default", margin: "auto" }}
          >
            Visit site
          </button>
        </Footer>
      </TextAdContainer>
    </TextAd>
  );
};

export default TextAd;
